import React from "react";
import { useEffect } from "react";
import { useState } from "react";

function getData({ page }) {
    return fetch(
        `https://jsonplaceholder.typicode.com/posts?_page=${page}_limit=6`
    ).then((res) => {
        return res.json();
    });
}

const Posts = () => {
    const [post, setPost] = useState([]);
    const [load, setLoad] = useState(false);
    const [page, setPage] = useState([1]);

    useEffect(() => {
        handFetch(page);
    }, [page]);

    const handFetch = async (page = 1) => {
        try {
            setLoad(true);
            const data = await getData({ page });
            setPost(data);
            setLoad(false);
        } catch (err) {
            console.log(err);
            setLoad(false);
        }
    };
    console.log(post);
    if (load) {
        return <h3>Loading...</h3>;
    }
    const handPage = (changeBy) => {
        setPage(page + changeBy);
    };
    return (
        <div>
            <h3>Posts</h3>
            <button onClick={handFetch}>Get</button>
            <ul>
                {post.map((item) => (
                    <li key={item.id}>{item.title} </li>
                ))}
            </ul>
            <button disabled={page===1} onClick={() => handPage(-1)}>
                Prev
            </button>
            <button>{page} </button>
            <button onClick={() => handPage(+1)}>Next</button>
        </div>
    );
};

export default Posts;
